/* eslint-disable */

import React, { useState, useEffect, useCallback } from "react";
import { removeBackground } from "@imgly/background-removal";
import axios from "axios";
import Joyride, { STATUS } from "react-joyride";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBTextArea,
  MDBCheckbox,
} from "mdb-react-ui-kit";
import { usePageState } from "../../context/AppStateContext";
import "./AddProductWizard.css";

import AutoFillLoader from "../Common/Loaders/AutoFillLoader";
import SubmissionLoader from "../Common/Loaders/SubmissionLoader";
import ImageUploadLoader from "../Common/Loaders/ImageUploadLoader";
import { useMessageBox } from "../Common/MessageBox";

import ebayLogo from "../../assets/marketplaces/ebay.svg";
import shopifyLogo from "../../assets/marketplaces/shopify.svg";
import depopLogo from "../../assets/marketplaces/depop.svg";
import vintedLogo from "../../assets/marketplaces/vinted.svg";
import poshmarkLogo from "../../assets/marketplaces/poshmark.svg";

const blurMessages = [
  "Analyzing image...",
  "Detecting image sharpness...",
  "Checking focus & clarity...",
];

const handleEbayIntegrate = async (e) => {
  e.stopPropagation();
  try {
    const res = await fetch(
      "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/ebayUrlFB",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    const data = await res.json();
    if (data?.url) {
      window.location.href = data.url;
    } else {
      console.error("eBay auth URL not received");
    }
  } catch (err) {
    console.error("eBay integrate error:", err);
  }
};

const AddProduct = () => {
  const { state: persistedState, setState: setPersistedState } =
    usePageState("addProduct");
  const { showError, showSuccess, showWarning, MessageBoxComponent } =
    useMessageBox();

  const [currentStep, setCurrentStep] = useState(
    () => persistedState.currentStep || 1,
  );
  const [processingImages, setProcessingImages] = useState(false);
  const [progress, setProgress] = useState(0);
  const [blurTextIndex, setBlurTextIndex] = useState(0);
  const [stepIndex, setStepIndex] = useState(0);
  const [run, setRun] = useState(false);
  const [activeMetafields, setActiveMetafields] = useState([]);
  const [loadingMetafields, setLoadingMetafields] = useState(false);
  const companyId = localStorage.getItem("company_id");

  const [poshmarkConnected, setPoshmarkConnected] = useState(false);
  const [checkingPoshmark, setCheckingPoshmark] = useState(false);
  const [poshmarkSubCategories, setPoshmarkSubCategories] = useState([]);

  const [ebayConnected, setEbayConnected] = useState(false);
  const [checkingEbay, setCheckingEbay] = useState(false);

  const [isAutoFilling, setIsAutoFilling] = useState(false);
  const [autoFillMessageIndex, setAutoFillMessageIndex] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStep, setSubmissionStep] = useState("");
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [autoFillResponse, setAutoFillResponse] = useState(null);

  const [savedEbayPolicies, setSavedEbayPolicies] = useState(null);

  const autoFillMessages = [
    "Analyze image",
    "Get the product details",
    "Authentication",
    "Condition",
    "Generating description",
  ];

  const poshmarkSubCategoriesMap = {
    Women: [
      "Accessories",
      "Bags",
      "Dresses",
      "Intimates & Sleepwear",
      "Jackets & Coats",
      "Jeans",
      "Jewelry",
      "Makeup",
      "Pants & Jumpsuits",
      "Shoes",
      "Shorts",
      "Skirts",
      "Sweaters",
      "Swim",
      "Tops",
      "Skincare",
      "Hair",
      "Bath & Body",
      "Global & Traditional Wear",
    ],
    Men: [
      "Accessories",
      "Jackets & Coats",
      "Jeans",
      "Pants",
      "Shirts",
      "Shoes",
      "Shorts",
      "Suits & Blazers",
      "Sweaters",
      "Swim",
      "Underwear & Socks",
      "Grooming",
      "Global & Traditional Wear",
      "Other",
    ],
    Kids: [
      "Accessories",
      "Bottoms",
      "Dresses",
      "Jackets & Coats",
      "Matching Sets",
      "One Pieces",
      "Pajamas",
      "Shirts & Tops",
      "Shoes",
      "Swim",
      "Costumes",
      "Bath, Skin & Hair",
      "Toys",
      "Other",
    ],
    Home: ["Furniture", "Decor", "Kitchen"],
    Pets: ["Food", "Toys", "Clothes"],
    Electronics: ["Mobiles", "Laptops", "Accessories"],
  };

  const [formData, setFormData] = useState(() => ({
    uploadedImages: persistedState.formData?.uploadedImages || [],
    categoryAspects: persistedState.formData?.categoryAspects || [],
    allCategoryAspects: persistedState.formData?.allCategoryAspects || [],
    categoryId: persistedState.formData?.categoryId || "",
    blurStatuses: persistedState.formData?.blurStatuses || [],
    imageProcessing: false,
    backgroundRemoval: persistedState.formData?.backgroundRemoval || false,
    blurDetection: persistedState.formData?.blurDetection || false,
    upscaleImage: persistedState.formData?.upscaleImage || false,

    title: persistedState.formData?.title || "",
    description: persistedState.formData?.description || "",
    sku: persistedState.formData?.sku || "",
    price: persistedState.formData?.price || "",
    pricerange: persistedState.formData?.pricerange || "",
    quantity: persistedState.formData?.quantity || "1",
    brand: persistedState.formData?.brand || "",
    color: persistedState.formData?.color || "",
    category: persistedState.formData?.category || "",
    condition: persistedState.formData?.condition || "",
    condition_summary: persistedState.formData?.condition_summary || "",
    authenticity_score: persistedState.formData?.authenticity_score || "",
    authenticity_summary: persistedState.formData?.authenticity_summary || "",
    material: persistedState.formData?.material || "",
    tags: persistedState.formData?.tags || "",
    metafields: persistedState.formData?.metafields || {},

    variants: persistedState.formData?.variants || [
      { id: 1, size: "", color: "", sku: "" },
    ],

    selectedMarketplaces: persistedState.formData?.selectedMarketplaces || [],

    poshmarkCategory: persistedState.formData?.poshmarkCategory || "Women",
    poshmarkSubCategory: persistedState.formData?.poshmarkSubCategory || "",
    poshmarkSizeType: persistedState.formData?.poshmarkSizeType || "standard",
    poshmarkAvailability:
      persistedState.formData?.poshmarkAvailability || "available",

    vintedCategory: persistedState.formData?.vintedCategory || "",
    vintedCategoryId: persistedState.formData?.vintedCategoryId || "",
    vintedCategoryPath: persistedState.formData?.vintedCategoryPath || [],
    vintedPackageSize: persistedState.formData?.vintedPackageSize || "medium",
    vintedSize: persistedState.formData?.vintedSize || "",
  }));

  useEffect(() => {
    const { imageProcessing, ...persistableFormData } = formData;
    setPersistedState({
      formData: persistableFormData,
      currentStep,
    });
  }, [formData, currentStep, setPersistedState]);

  useEffect(() => {
    setRun(true);
  }, []);

  const stepstofollow = [
    {
      target: "#image-upload",
      content: "Upload your product images",
      disableBeacon: true,
      hideFooter: true,
      disableOverlayClose: true,
    },
  ];

  const fetchActiveMetafields = async () => {
    setLoadingMetafields(true);
    try {
      const response = await fetch(
        `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getActiveShopifyMetafields/${companyId}`,
      );
      const result = await response.json();
      if (result.success) {
        console.log(result);
        setActiveMetafields(result.data.active_metafields);
      }
    } catch (err) {
      console.error("API fetch error:", err);
    } finally {
      setLoadingMetafields(false);
    }
  };

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if (status === STATUS.FINISHED) {
      setRun(false);
    }
  };

  const moveNext = () => {
    setStepIndex((prev) => prev + 1);
  };

  const steps = [
    { id: 1, title: "Image Upload" },
    { id: 2, title: "Listing Details" },
    { id: 3, title: "Marketplaces" },
    { id: 4, title: "Image Processing" },
    { id: 5, title: "Review" },
  ];

  useEffect(() => {
    fetchActiveMetafields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Check eBay store connection status
  useEffect(() => {
    const checkEbayStore = async () => {
      if (!formData.selectedMarketplaces.includes("ebay")) {
        setEbayConnected(false);
        return;
      }

      const companyId = localStorage.getItem("company_id");
      if (!companyId) {
        setEbayConnected(false);
        return;
      }

      try {
        setCheckingEbay(true);
        const res = await fetch(
          `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getEbayStoreByCompany/${companyId}`,
        );
        const data = await res.json();

        if (res.ok && data.success && data.data) {
          setEbayConnected(true);
        } else {
          setEbayConnected(false);
        }
      } catch (err) {
        console.error("eBay store check error:", err);
        setEbayConnected(false);
      } finally {
        setCheckingEbay(false);
      }
    };

    checkEbayStore();
  }, [formData.selectedMarketplaces]);

  useEffect(() => {
    if (!formData.imageProcessing) return;
    const interval = setInterval(() => {
      setBlurTextIndex((prev) => (prev + 1) % blurMessages.length);
    }, 1500);
    return () => clearInterval(interval);
  }, [formData.imageProcessing]);

  useEffect(() => {
    if (!isAutoFilling) return;
    const interval = setInterval(() => {
      setAutoFillMessageIndex((prev) => (prev + 1) % autoFillMessages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [isAutoFilling, autoFillMessages.length]);

  useEffect(() => {
    const checkPoshmarkStatus = async () => {
      if (!formData.selectedMarketplaces.includes("poshmark")) {
        setPoshmarkConnected(false);
        return;
      }
      setCheckingPoshmark(true);
      try {
        const res = await fetch(
          "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/extension-status",
        );
        const data = await res.json();
        setPoshmarkConnected(data.connected);
        if (data.connected) {
          console.log("Poshmark extension connected");
        }
      } catch (err) {
        console.error("Poshmark status check failed:", err);
        setPoshmarkConnected(false);
      } finally {
        setCheckingPoshmark(false);
      }
    };
    checkPoshmarkStatus();
    const interval = setInterval(checkPoshmarkStatus, 30000);
    return () => clearInterval(interval);
  }, [formData.selectedMarketplaces]);

  const handlePoshmarkIntegrate = async (e) => {
    e.stopPropagation();
    try {
      setCheckingPoshmark(true);
      const statusRes = await fetch(
        "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/extension-status",
      );
      const statusData = await statusRes.json();
      if (!statusData.connected) {
        showWarning(
          "Please open Poshmark website in Chrome and refresh the page!",
        );
        window.open("https://poshmark.com/create-listing", "_blank");
      } else {
        showSuccess("Poshmark extension is connected and ready!");
        setPoshmarkConnected(true);
      }
    } catch (err) {
      console.error("Poshmark integration error:", err);
      showError("Failed to check Poshmark extension status");
    } finally {
      setCheckingPoshmark(false);
    }
  };

  const handlePoshmarkCategoryChange = (category) => {
    handleInputChange("poshmarkCategory", category);
    handleInputChange("poshmarkSubCategory", "");
    if (category && poshmarkSubCategoriesMap[category]) {
      setPoshmarkSubCategories(poshmarkSubCategoriesMap[category]);
    } else {
      setPoshmarkSubCategories([]);
    }
  };

  const uploadToPoshmark = async () => {
    setSubmissionStep("Uploading to Poshmark...");
    try {
      const healthCheck = await fetch(
        "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/extension-status",
      );
      const healthData = await healthCheck.json();
      if (!healthData.connected) {
        throw new Error(
          "Poshmark extension not connected. Please open Poshmark tab and refresh.",
        );
      }
      const files = formData.uploadedImages;
      const imagesBase64 = await Promise.all(
        files.map(async (url) => {
          const res = await fetch(url);
          const blob = await res.blob();
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(blob);
          });
        }),
      );
      if (imagesBase64.length === 0) {
        throw new Error("No valid images to upload");
      }
      const conditionMap = {
        new: "New With Tags",
        "like-new": "Like New",
        excellent: "Like New",
        good: "Like New",
        fair: "Like New",
        poor: "Like New",
      };
      const poshmarkPayload = {
        title: formData.title || "Product Listing",
        description: formData.description || "No description provided",
        price: parseFloat(formData.price || "1.00").toString(),
        category: formData.poshmarkCategory || "Women",
        subCategory: formData.poshmarkSubCategory || "Dresses",
        brand: formData.brand || "",
        sizeType: formData.poshmarkSizeType || "standard",
        size: formData.variants?.[0]?.size || "OS",
        condition: conditionMap[formData.condition] || "New With Tags",
        originalPrice: formData.pricerange?.split(" - ")[1] || "",
        color: formData.color || "",
        availability: formData.poshmarkAvailability || "available",
        images: imagesBase64,
      };
      console.log("Poshmark Payload:", poshmarkPayload);
      const poshmarkRes = await fetch(
        "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/start-automation",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(poshmarkPayload),
        },
      );
      const poshmarkData = await poshmarkRes.json();
      console.log("Poshmark Response:", poshmarkData);
      if (poshmarkRes.ok && poshmarkData.success) {
        return {
          success: true,
          data: poshmarkData,
          message: "Poshmark automation started! Check your browser.",
        };
      } else {
        throw new Error(poshmarkData.error || "Poshmark upload failed");
      }
    } catch (err) {
      console.error("Poshmark Error:", err);
      return {
        success: false,
        error: err.message,
      };
    }
  };

  const conditions = [
    { value: "new", label: "New" },
    { value: "like-new", label: "Like New" },
    { value: "excellent", label: "Excellent" },
    { value: "good", label: "Good" },
    { value: "fair", label: "Fair" },
    { value: "poor", label: "Poor" },
  ];

  const marketplaces = [
    { id: "ebay", name: "eBay", logo: ebayLogo },
    { id: "shopify", name: "Shopify", logo: shopifyLogo },
    { id: "poshmark", name: "Poshmark", logo: poshmarkLogo },
    { id: "vinted", name: "Vinted", logo: vintedLogo },
    { id: "depop", name: "Depop", logo: depopLogo },
  ];

  const availableMarketplaces = [
    { id: "ebay", name: "eBay", logo: ebayLogo },
    { id: "shopify", name: "Shopify", logo: shopifyLogo },
    { id: "poshmark", name: "Poshmark", logo: poshmarkLogo },
    { id: "vinted", name: "Vinted", logo: vintedLogo },
  ];

  const upcomingMarketplaces = [
    { id: "depop", name: "Depop", logo: depopLogo },
  ];

  const [processedImages, setProcessedImages] = useState([]);
  const [processing, setProcessing] = useState(false);

  const [vintedMainCategories, setVintedMainCategories] = useState([]);
  const [vintedSubCategories, setVintedSubCategories] = useState([]);
  const [vintedCategoryHistory, setVintedCategoryHistory] = useState([]);
  const [vintedCurrentCategoryId, setVintedCurrentCategoryId] = useState(null);
  const [vintedSelectedCategoryPath, setVintedSelectedCategoryPath] = useState(
    [],
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps

  const [vintedSelectedCategoryId, setVintedSelectedCategoryId] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const [vintedSelectedCategoryName, setVintedSelectedCategoryName] =
    useState("");

  const [vintedConnected, setVintedConnected] = useState(false);
  const [checkingVinted, setCheckingVinted] = useState(false);
  const [vintedLoadingCategories, setVintedLoadingCategories] = useState(false);

  const fetchVintedMainCategories = async () => {
    setVintedLoadingCategories(true);
    try {
      const res = await fetch(
        "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/categories/main",
      );
      const data = await res.json();
      if (data.success) {
        setVintedMainCategories(data.categories);
      } else {
        showError("Failed to load Vinted categories");
      }
    } catch (err) {
      console.error("Vinted categories fetch error:", err);
      showError("Could not connect to Vinted categories server");
    } finally {
      setVintedLoadingCategories(false);
    }
  };

  const fetchVintedSubCategories = async (parentCategoryId) => {
    setVintedLoadingCategories(true);
    try {
      const res = await fetch(
        `https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/categories/sub/${parentCategoryId}`,
      );
      const data = await res.json();
      if (data.success) {
        setVintedSubCategories(data.subcategories);
        return data.subcategories;
      } else {
        showError("Failed to load Vinted subcategories");
        return [];
      }
    } catch (err) {
      console.error("Vinted subcategories fetch error:", err);
      showError("Could not connect to Vinted categories server");
      return [];
    } finally {
      setVintedLoadingCategories(false);
    }
  };

  const fetchVintedCategoryPath = async (categoryId) => {
    try {
      const res = await fetch(
        `https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/categories/path/${categoryId}`,
      );
      const data = await res.json();
      if (data.success) {
        return data.path || [];
      } else {
        return [];
      }
    } catch (err) {
      console.error("Vinted category path error:", err);
      return [];
    }
  };

  const handleVintedCategoryClick = async (category) => {
    if (category.is_final_selection) {
      const path = await fetchVintedCategoryPath(category.category_id);
      const pathNames = path.map((cat) => cat.name);
      setFormData((prev) => ({
        ...prev,
        vintedCategory: pathNames.join(" > "),
        vintedCategoryId: category.category_id,
        vintedCategoryPath: pathNames,
      }));
      setVintedSelectedCategoryPath(pathNames);
      setVintedSelectedCategoryId(category.category_id);
      setVintedSelectedCategoryName(category.name);
      setVintedCurrentCategoryId(null);
      setVintedCategoryHistory([]);
    } else {
      setVintedCategoryHistory((prev) => [
        ...prev,
        {
          categoryId: vintedCurrentCategoryId,
          categoryName:
            vintedSelectedCategoryPath[vintedSelectedCategoryPath.length - 1] ||
            "",
        },
      ]);
      setVintedSelectedCategoryPath((prev) => [...prev, category.name]);
      setVintedCurrentCategoryId(category.category_id);
      const subs = await fetchVintedSubCategories(category.category_id);
      setVintedSubCategories(subs);
    }
  };

  const handleVintedBack = async () => {
    if (vintedCategoryHistory.length > 0) {
      const newPath = [...vintedSelectedCategoryPath];
      newPath.pop();
      setVintedSelectedCategoryPath(newPath);
      const prevCategory =
        vintedCategoryHistory[vintedCategoryHistory.length - 1];
      setVintedCategoryHistory((prev) => prev.slice(0, -1));
      setVintedCurrentCategoryId(prevCategory.categoryId);
      if (prevCategory.categoryId) {
        await fetchVintedSubCategories(prevCategory.categoryId);
      } else {
        setVintedCurrentCategoryId(null);
      }
    } else {
      setVintedCurrentCategoryId(null);
      setVintedSelectedCategoryPath([]);
    }
  };

  const resetVintedCategory = () => {
    setFormData((prev) => ({
      ...prev,
      vintedCategory: "",
      vintedCategoryId: "",
      vintedCategoryPath: [],
    }));
    setVintedSelectedCategoryPath([]);
    setVintedSelectedCategoryId("");
    setVintedSelectedCategoryName("");
    setVintedCurrentCategoryId(null);
    setVintedCategoryHistory([]);
    fetchVintedMainCategories();
  };

  const getVintedCategoryIcon = (categoryName) => {
    const lower = categoryName.toLowerCase();
    if (lower.includes("woman") || lower.includes("women")) return "👩";
    if (lower.includes("man") || lower.includes("men")) return "👨";
    if (lower.includes("kid") || lower.includes("child")) return "👶";
    if (lower.includes("home")) return "🏠";
    if (lower.includes("electronic")) return "📱";
    if (lower.includes("sport")) return "⚽";
    if (
      lower.includes("cloth") ||
      lower.includes("dress") ||
      lower.includes("shirt")
    )
      return "👕";
    if (lower.includes("shoe")) return "👟";
    if (lower.includes("bag")) return "👜";
    if (lower.includes("accessory")) return "⌚";
    if (lower.includes("toy")) return "🧸";
    if (lower.includes("book")) return "📚";
    if (lower.includes("beauty") || lower.includes("makeup")) return "💄";
    return "📁";
  };

  const handleVintedIntegrate = async (e) => {
    e.stopPropagation();
    try {
      setCheckingVinted(true);

      // Pehle check karo extension connected hai ya nahi
      const res = await fetch(
        "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/health-vinted",
      );
      const data = await res.json();

      if (data.connected) {
        // ✅ Already connected - Directly Vinted new listing page kholo
        showSuccess("Opening Vinted listing page...");
        window.open("https://www.vinted.com/items/new", "_blank");
        setVintedConnected(true);
      } else {
        // ❌ Not connected - User ko guide karo
        showWarning(
          "Please open Vinted website in Chrome and refresh the page!",
        );
        window.open("https://www.vinted.com/items/new", "_blank");
        setVintedConnected(false);
      }
    } catch (err) {
      console.error("Vinted integration error:", err);
      showError("Failed to check Vinted extension status");
      setVintedConnected(false);
    } finally {
      setCheckingVinted(false);
    }
  };

  const uploadToVinted = async () => {
    setSubmissionStep("Uploading to Vinted...");
    try {
      const healthCheck = await fetch(
        "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/health-vinted",
      );
      const healthData = await healthCheck.json();
      if (!healthData.connected) {
        throw new Error(
          "Vinted extension not connected. Please open Vinted tab and refresh.",
        );
      }
      const files = formData.uploadedImages;
      const imagesBase64 = await Promise.all(
        files.map(async (url) => {
          const res = await fetch(url);
          const blob = await res.blob();
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(blob);
          });
        }),
      );
      if (imagesBase64.length === 0) {
        throw new Error("No valid images to upload");
      }
      const conditionMap = {
        new: "New with tags",
        "like-new": "Very good",
        excellent: "Very good",
        good: "Good",
        fair: "Satisfactory",
        poor: "Satisfactory",
      };
      const payload = {
        title: formData.title,
        description: formData.description,
        price: parseFloat(formData.price || "1.00"),
        category: formData.vintedCategory,
        categoryId: formData.vintedCategoryId,
        brand: formData.brand || "",
        condition: conditionMap[formData.condition] || "Very good",
        size: formData.vintedSize,
        packageSize: formData.vintedPackageSize,
        color: formData.color || "",
        images: imagesBase64,
      };
      console.log("Vinted Payload:", payload);
      const res = await fetch(
        "https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net/api/start-automation-vinted",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      console.log("Vinted Response:", data);
      if (data.success) {
        return {
          success: true,
          data: data,
          message: "Vinted automation started! Check your browser.",
        };
      } else {
        throw new Error(data.error || "Vinted upload failed");
      }
    } catch (err) {
      console.error("Vinted Error:", err);
      return {
        success: false,
        error: err.message,
      };
    }
  };

  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;
    const validTypes = ["image/jpeg", "image/png", "image/webp"];
    const maxSize = 5 * 1024 * 1024;
    const validFiles = files.filter((file) => {
      if (!validTypes.includes(file.type)) {
        showWarning(`${file.name} is not a valid image.`);
        return false;
      }
      if (file.size > maxSize) {
        showWarning(`${file.name} exceeds 5MB.`);
        return false;
      }
      return true;
    });
    if (!validFiles.length) return;
    setFormData((prev) => ({
      ...prev,
      imageProcessing: true,
      title: "",
      description: "",
      brand: "",
      category: "",
      material: "",
      color: "",
      price: "",
      pricerange: "",
      condition: "",
      condition_summary: "",
      authenticity_score: "",
      authenticity_summary: "",
      tags: "",
      categoryAspects: [],
      allCategoryAspects: [],
      categoryId: "",
    }));
    try {
      const formDataObj = new FormData();
      validFiles.forEach((file) => formDataObj.append("images", file));
      const blurRes = await fetch(
        "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/blur/blur-detect",
        {
          method: "POST",
          body: formDataObj,
        },
      );
      if (!blurRes.ok) throw new Error("Blur detection failed");
      const blurResults = await blurRes.json();
      if (!Array.isArray(blurResults)) {
        throw new Error("Invalid blur API response");
      }
      const acceptedImages = [];
      const blurStatuses = [];
      blurResults.forEach((item) => {
        const file = validFiles.find((f) => f.name === item.filename);
        if (!file) return;
        const isRejected = item.result.status === "rejected";
        blurStatuses.push(isRejected);
        acceptedImages.push(URL.createObjectURL(file));
      });
      setFormData((prev) => ({
        ...prev,
        uploadedImages: [...prev.uploadedImages, ...acceptedImages],
        blurStatuses,
      }));
    } catch (err) {
      console.error("Blur detection error:", err);
      showError("Failed to process images");
    } finally {
      setFormData((prev) => ({ ...prev, imageProcessing: false }));
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const fakeEvent = { target: { files: files } };
      handleFileUpload(fakeEvent);
    }
  };

  const handleStartImageEditing = async () => {
    if (!formData.uploadedImages.length) return;
    setProcessing(true);
    setProcessedImages([]);
    try {
      const finalImages = [];
      for (let i = 0; i < formData.uploadedImages.length; i++) {
        const res = await fetch(formData.uploadedImages[i]);
        const blob = await res.blob();
        const file = new File([blob], `image-${i + 1}.png`, {
          type: blob.type,
        });
        const form = new FormData();
        form.append("image", file);
        const response = await axios.post(
          "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/image/ghost-mannequin",
          form,
        );
        if (!response.data?.success || !response.data?.image) {
          throw new Error("Ghost mannequin processing failed");
        }
        const processedBase64 = response.data.image;
        const base64Response = await fetch(processedBase64);
        const processedBlob = await base64Response.blob();
        const processedFile = new File([processedBlob], `ghost-${i + 1}.png`, {
          type: processedBlob.type,
        });
        finalImages.push(URL.createObjectURL(processedFile));
      }
      setProcessedImages(finalImages);
      showSuccess("Image processing completed!");
    } catch (err) {
      console.error("Ghost mannequin error:", err);
      showError("Ghost mannequin processing failed");
    } finally {
      setProcessing(false);
    }
  };

  const handleInputChange = (field, value) => {
    if (field.startsWith("metafields.")) {
      const key = field.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        metafields: {
          ...prev.metafields,
          [key]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleVariantChange = (variantId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      variants: prev.variants.map((variant) =>
        variant.id === variantId ? { ...variant, [field]: value } : variant,
      ),
    }));
  };

  const addVariant = () => {
    const newId = Math.max(...formData.variants.map((v) => v.id), 0) + 1;
    setFormData((prev) => ({
      ...prev,
      variants: [...prev.variants, { id: newId, size: "", color: "", sku: "" }],
    }));
  };

  const removeVariant = (variantId) => {
    if (formData.variants.length > 1) {
      setFormData((prev) => ({
        ...prev,
        variants: prev.variants.filter((variant) => variant.id !== variantId),
      }));
    }
  };
  const getEbayPolicies = async () => {
    const company_id = localStorage.getItem("company_id");
    console.log("company_id", company_id);
    if (!company_id) return; // ❌ no company id → exit

    try {
      // 1️⃣ get ebay policies
      // const res = await fetch(
      //   `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getEbayPolicies/${company_id}`,
      // );
      // const policies = await res.json();

      // 2️⃣ get saved ebay policies
      const savedRes = await fetch(
        `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getSavedEbayPolicies/${company_id}`,
      );
      const savedPolicies = await savedRes.json();

      setSavedEbayPolicies(savedPolicies);
      // 3️⃣ just store responses (no setSelected)
      //setEbayPolicies(policies);
      setSavedEbayPolicies(savedPolicies);
    } catch (error) {
      console.error("eBay policy fetch failed:", error);
    }
  };

  const handleMarketplaceToggle = (marketplaceId) => {
    setFormData((prev) => {
      const updatedMarketplaces = prev.selectedMarketplaces.includes(
        marketplaceId,
      )
        ? prev.selectedMarketplaces.filter((id) => id !== marketplaceId)
        : [...prev.selectedMarketplaces, marketplaceId];

      console.log("selected marketplaces", updatedMarketplaces);

      return {
        ...prev,
        selectedMarketplaces: updatedMarketplaces,
      };
    });

    if (marketplaceId === "vinted") {
      fetchVintedMainCategories();
    }

    if (marketplaceId === "ebay") {
      getEbayPolicies();
    }
  };

  const nextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep((prev) => prev + 1);
      if (currentStep === 6) {
        runImageProcessing();
      }
    }
  };

  const runImageProcessing = async () => {
    setProcessingImages(true);
    setProgress(0);
    const finalImages = [];
    for (let i = 0; i < formData.uploadedImages.length; i++) {
      await new Promise((resolve) => setTimeout(resolve, 50));
      try {
        let res = await fetch(formData.uploadedImages[i]);
        let blob = await res.blob();
        let file = new File([blob], `image-${i + 1}.png`, { type: blob.type });
        if (formData.upscaleImage) {
          const form = new FormData();
          form.append("images", file);
          const response = await axios.post(
            "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/scaleup/scale-up",
            form,
          );
          const scaledUrl = response.data?.[0]?.result?.url;
          const scaledBlob = await (await fetch(scaledUrl)).blob();
          file = new File([scaledBlob], `scaled-${i + 1}.png`, {
            type: scaledBlob.type,
          });
        }
        if (formData.backgroundRemoval) {
          const bgBlob = await removeBackground(file);
          file = new File([bgBlob], `bg-${i + 1}.png`, { type: bgBlob.type });
        }
        finalImages.push(URL.createObjectURL(file));
        setProcessedImages([...finalImages]);
        setProgress(
          Math.round(((i + 1) / formData.uploadedImages.length) * 100),
        );
      } catch (err) {
        console.error("Image processing failed for image", i, err);
      }
    }
    setProcessingImages(false);
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const goToStep = (stepId) => {
    if (stepId <= getMaxAccessibleStep()) {
      setCurrentStep(stepId);
    }
  };

  const getMaxAccessibleStep = () => {
    let maxStep = 1;
    if (formData.uploadedImages.length > 0) maxStep = 2;
    if (
      formData.uploadedImages.length > 0 &&
      formData.title &&
      formData.description &&
      formData.sku &&
      formData.price &&
      formData.quantity
    ) {
      maxStep = 3;
    }
    if (
      formData.uploadedImages.length > 0 &&
      formData.title &&
      formData.description &&
      formData.sku &&
      formData.price &&
      formData.quantity &&
      formData.selectedMarketplaces.length > 0
    ) {
      maxStep = 4;
    }
    if (
      formData.uploadedImages.length &&
      formData.title &&
      formData.description &&
      formData.sku &&
      formData.price &&
      formData.quantity &&
      formData.selectedMarketplaces.length > 0
    ) {
      maxStep = 5;
    }
    return maxStep;
  };

  const isStepClickable = (stepId) => {
    return stepId <= getMaxAccessibleStep();
  };

  const isStepValid = () => {
    switch (currentStep) {
      case 1:
        return formData.uploadedImages.length > 0;
      case 2:
        return (
          formData.title &&
          formData.description &&
          formData.sku &&
          formData.price &&
          formData.quantity
        );
      case 3:
        return formData.selectedMarketplaces.length > 0;
      case 4:
        return true;
      case 5:
        return true;
      default:
        return false;
    }
  };

  const removeImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      uploadedImages: prev.uploadedImages.filter((_, i) => i !== index),
      blurStatuses: prev.blurStatuses.filter((_, i) => i !== index),
    }));
  };

  const [loadingAspects, setLoadingAspects] = useState(false);

  const handleCategoryAspects = useCallback(async (categoryTerm) => {
    try {
      setLoadingAspects(true);
      const companyId = localStorage.getItem("company_id");
      const catResponse = await fetch(
        `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getCategoriesFBThriftops/${companyId}?category_term=${categoryTerm}`,
        { method: "POST", headers: { "Content-Type": "application/json" } },
      );
      const catData = await catResponse.json();
      if (!catData.suggestedCategories?.length) {
        setLoadingAspects(false);
        return;
      }
      const firstCategory = catData.suggestedCategories[0].category;
      const aspectsResponse = await fetch(
        `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getCategoryAspectsRAPIDAPI/${companyId}?category_id=${firstCategory.categoryId}`,
        { method: "POST", headers: { "Content-Type": "application/json" } },
      );
      const aspectsData = await aspectsResponse.json();
      setFormData((prev) => {
        const mappedAspects =
          aspectsData.category_aspects?.aspects
            .filter(
              (aspect) =>
                (aspect.aspectConstraint?.aspectUsage || "").toUpperCase() ===
                "RECOMMENDED",
            )
            .map((aspect) => {
              const key = aspect.localizedAspectName
                .replace(/\s+/g, "_")
                .toLowerCase();
              return {
                ...aspect,
                key,
                value: prev[key] || "",
              };
            }) || [];
        const newValues = {};
        mappedAspects.forEach((a) => {
          if (a.value) newValues[a.key] = a.value;
        });
        const allAspects =
          aspectsData.category_aspects?.aspects.map((aspect) => {
            const key = aspect.localizedAspectName
              .replace(/\s+/g, "_")
              .toLowerCase();
            return {
              ...aspect,
              key,
              value: prev[key] || "",
            };
          }) || [];
        return {
          ...prev,
          ...newValues,
          categoryAspects: mappedAspects,
          categoryId: firstCategory.categoryId,
          allCategoryAspects: allAspects,
        };
      });
      setLoadingAspects(false);
    } catch (err) {
      console.error("Error fetching aspects:", err);
      setLoadingAspects(false);
    }
  }, []);

  const [mappedSent, setMappedSent] = useState(false);

  useEffect(() => {
    if (
      !mappedSent &&
      autoFillResponse &&
      Array.isArray(formData.categoryAspects) &&
      formData.categoryAspects.length > 0
    ) {
      sendMappedCategories({
        autofillResponse: autoFillResponse,
        mappedAspects: formData.categoryAspects,
      });
      setMappedSent(true);
    }
  }, [autoFillResponse, formData.categoryAspects, mappedSent]);

  const sendMappedCategories = async ({ autofillResponse, mappedAspects }) => {
    try {
      const res = await fetch(
        "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getMappedCategories",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            autofillResponse,
            mappedAspects,
          }),
        },
      );
      const data = await res.json();
      console.log("Backend combined response:", data);
      console.log("Filled aspects from Gemini:", data.geminiFilledAspects);
      const filled = data.geminiFilledAspects || [];
      setFormData((prev) => {
        const updatedAspects = prev.categoryAspects.map((aspect) => {
          const filledAspect = filled.find((f) => f.key === aspect.key);
          return {
            ...aspect,
            value: filledAspect?.value || "N/A",
          };
        });
        return {
          ...prev,
          categoryAspects: updatedAspects,
        };
      });
    } catch (err) {
      console.error("Failed to send combined data:", err);
    }
  };

  useEffect(() => {
    if (typeof formData.category === "string" && formData.category.trim()) {
      handleCategoryAspects(formData.category);
    }
  }, [formData.category, handleCategoryAspects]);

  const handleAspectChange = (key, val) => {
    setFormData((prev) => ({
      ...prev,
      categoryAspects: prev.categoryAspects.map((a) =>
        a.key === key ? { ...a, value: val } : a,
      ),
      [key]: val,
    }));
  };

  const handleAutoFill = async () => {
    if (!formData.uploadedImages.length) {
      showWarning("Please upload at least one image first!");
      return;
    }
    try {
      setIsAutoFilling(true);
      setAutoFillMessageIndex(0);
      const form = new FormData();
      for (let i = 0; i < formData.uploadedImages.length; i++) {
        const res = await fetch(formData.uploadedImages[i]);
        const blob = await res.blob();
        form.append("images", blob, `product-${i + 1}.png`);
      }
      await sendAutoFillRequest(form);
    } catch (err) {
      console.error("AutoFill Error", err);
      showError("Auto-fill failed");
    } finally {
      setIsAutoFilling(false);
    }
  };

  const buildMetafieldsFromAnalysis = (activeMetafields, responseData) => {
    const result = {};

    const analysis = responseData?.analysis || {};
    const aiMetafields = analysis.metafields || {};
    const productMeta = responseData?.product_metadata || {};

    activeMetafields.forEach((mf) => {
      const key = mf.key;

      if (aiMetafields.hasOwnProperty(key)) {
        result[key] = aiMetafields[key] || "";
      } else if (analysis.hasOwnProperty(key)) {
        result[key] = analysis[key] || "";
      } else if (productMeta.hasOwnProperty(key)) {
        result[key] = productMeta[key] || "";
      } else {
        result[key] = "";
      }
      console.log("result[key]", result[key]);
    });

    return result;
  };

  const sendAutoFillRequest = async (form) => {
    try {
      // Just extract keys from activeMetafields
      if (activeMetafields && activeMetafields.length > 0) {
        console.log("Sending full metafields objects:", activeMetafields);
        form.append("metafields", JSON.stringify(activeMetafields));
      }
      // Now send the request
      const response = await axios.post(
        "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/autofill/analyze",
        form,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      console.log("Analyze response:", response.data);
      setAutoFillResponse(response.data);

      // Map metafields
      const data = response.data;

      // 🔥 yeh important line hai
      const mappedMetafields = buildMetafieldsFromAnalysis(
        activeMetafields,
        data,
      );

      console.log("mappedMetafields", mappedMetafields);
      // You can still update formData as before
      const analysis = response.data.analysis || {};
      const product_metadata = response.data.product_metadata || {};
      const price = response.data.price || {};
      const authenticity = response.data.authenticity || {};

      const conditionScore = Number(analysis.condition || 0);
      let condition = "POOR";
      if (conditionScore >= 10) condition = "NEW";
      else if (conditionScore >= 9) condition = "LIKE-NEW";
      else if (conditionScore >= 8) condition = "EXCELLENT";
      else if (conditionScore >= 7) condition = "GOOD";
      else if (conditionScore >= 6) condition = "FAIR";

      const hierarchy = analysis.category || product_metadata.category || {};
      const categoryString = [
        hierarchy.l1_gender,
        hierarchy.l2_type,
        hierarchy.l3_category,
        hierarchy.l4_subcategory,
      ]
        .filter(Boolean)
        .join(" > ");

      setFormData((prev) => ({
        ...prev,
        metafields: mappedMetafields,
        title: analysis.seo_title || product_metadata.title || prev.title,
        description:
          analysis.seo_description ||
          product_metadata.description ||
          prev.description,
        sku: product_metadata.sku || prev.sku,
        brand: analysis.brand || "N/A",
        category: categoryString || prev.category,
        material: analysis.material || prev.material,
        color: analysis.color || prev.color,
        price: price.recommended || prev.price,
        pricerange:
          price.low && price.high
            ? `${price.low} - ${price.high}`
            : prev.pricerange,
        condition,
        condition_summary:
          analysis.condition_summary ||
          analysis.condition?.summary ||
          prev.condition_summary,
        authenticity_score: authenticity.score || prev.authenticity_score,
        authenticity_summary: authenticity.summary || prev.authenticity_summary,
        tags: analysis.seo_tags
          ? analysis.seo_tags.split(",").map((t) => t.trim())
          : product_metadata.seo_tags
            ? product_metadata.seo_tags.split(",").map((t) => t.trim())
            : prev.tags,
      }));
    } catch (err) {
      console.error("API Error:", err);
      showError("Auto-fill failed");
    }
  };

  const buildEbayAspects = (categoryAspects = []) => {
    const aspects = {};
    categoryAspects.forEach((a) => {
      aspects[a.localizedAspectName] =
        a.value && a.value.trim() !== "" ? [a.value] : ["N/A"];
    });
    return aspects;
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      setSubmissionSuccess(false);
      setSubmissionStep("Preparing product data...");
      const selectedMps = formData.selectedMarketplaces || [];
      if (selectedMps.length === 0) {
        showWarning("Please select at least one marketplace!");
        setIsSubmitting(false);
        return;
      }
      const companyId = localStorage.getItem("company_id");
      const results = [];

      if (selectedMps.includes("shopify")) {
        setSubmissionStep("Uploading to Shopify...");
        try {
          const urlToBase64 = async (url) => {
            const res = await fetch(url);
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result.split(",")[1]);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
          };
          const images = [];
          for (let i = 0; i < formData.uploadedImages.length; i++) {
            const base64 = await urlToBase64(formData.uploadedImages[i]);
            images.push({
              attachment: base64,
              alt: `Product Image ${i + 1}`,
            });
          }
          const metafieldsArray = [];
          if (
            formData.metafields &&
            Object.keys(formData.metafields).length > 0
          ) {
            Object.entries(formData.metafields).forEach(([key, value]) => {
              if (value?.trim()) {
                const metafieldDef = activeMetafields.find(
                  (mf) => mf.key === key,
                );
                metafieldsArray.push({
                  namespace: metafieldDef?.namespace || "custom",
                  key: key,
                  value: value,
                  type: metafieldDef?.type || "single_line_text_field",
                });
              }
            });
          }
          const payload = {
            product: {
              title: formData.title || "Test Product",
              body_html: formData.description || "<p>Description</p>",
              vendor: formData.brand || "Brand",
              product_type: formData.category || "Misc",
              variants: [
                {
                  option1: "Default",
                  price: String(formData.price || "1.00"),
                  sku: formData.sku || `SKU-${Date.now()}`,
                  inventory_quantity: parseInt(formData.quantity || 1),
                  inventory_management: "shopify",
                },
              ],
              images,
              metafields: metafieldsArray,
            },
          };

          console.log("shopify payload:", payload);
          const res = await fetch(
            `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/shopify/create/${companyId}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            },
          );
          const data = await res.json();

          if (res.ok) {
            results.push({ marketplace: "shopify", success: true, data });
            showSuccess("Shopify listing created successfully!");
          } else {
            throw new Error(data.message || "Shopify upload failed");
          }
        } catch (err) {
          console.error("Shopify Error:", err);
          results.push({
            marketplace: "shopify",
            success: false,
            error: err.message,
          });
          showError(`Shopify failed: ${err.message}`);
        }
      }

      if (selectedMps.includes("ebay")) {
        setSubmissionStep("Uploading to eBay...");
        try {
          // Convert blob URLs to hosted URLs for eBay
          setSubmissionStep("Converting images for eBay...");
          const urlToHostedUrl = async (url) => {
            // If it's already a hosted URL (starts with http/https and not blob), return as is
            if (
              typeof url === "string" &&
              url.startsWith("http") &&
              !url.startsWith("blob:")
            ) {
              return url;
            }

            // If it's a blob URL, we need to upload it to get a hosted URL
            // Check if user has upscaled images (processed images with hosted URLs)
            // If not, we'll need to upload the blob to get a hosted URL
            // For now, if it's a blob URL and not already processed, we'll skip it
            // and let the backend handle it, or we can convert to base64
            try {
              const res = await fetch(url);
              const blob = await res.blob();

              // Convert blob to base64
              const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  const base64String = reader.result.split(",")[1];
                  resolve(base64String);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              });

              // Upload image to get hosted URL (using a direct upload endpoint, not scale-up)
              // Note: You may need to adjust this endpoint based on your backend API
              const uploadRes = await fetch(
                "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/image/upload",
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    image: base64,
                    filename: `ebay-image-${Date.now()}.png`,
                  }),
                },
              );

              if (uploadRes.ok) {
                const uploadData = await uploadRes.json();
                return (
                  uploadData.url || uploadData.imageUrl || uploadData.image_url
                );
              } else {
                // If upload endpoint doesn't exist, return null and we'll handle it
                console.warn(
                  "Image upload endpoint not available, using blob URL",
                );
                return null;
              }
            } catch (err) {
              console.error("Error converting image URL:", err);
              return null;
            }
          };

          // Check processed images first - if user upscaled, they'll have hosted URLs
          // Otherwise, use uploaded images
          const imagesToProcess =
            processedImages.length > 0
              ? processedImages
              : formData.uploadedImages;

          // Convert all images to hosted URLs
          const imageUrls = [];
          for (let i = 0; i < Math.min(imagesToProcess.length, 10); i++) {
            const url = imagesToProcess[i];

            // If already hosted (from upscaling), use directly
            if (
              typeof url === "string" &&
              url.startsWith("http") &&
              !url.startsWith("blob:")
            ) {
              imageUrls.push(url);
            } else {
              // Try to convert blob URL to hosted URL
              const hostedUrl = await urlToHostedUrl(url);
              if (hostedUrl) {
                imageUrls.push(hostedUrl);
              }
            }
          }

          const finalImageUrls =
            imageUrls.length > 0
              ? imageUrls
              : ["https://via.placeholder.com/500"];

          console.log("eBay image URLs:", finalImageUrls);

          const ebayPayload = {
            SKU: formData.sku || `SKU-${Date.now()}`,
            days: 0,
            marketplace_id: "EBAY_US",
            email: "test@example.com",
            categoryId: formData.categoryId || "177837",

            InventoryItem: {
              availability: {
                shipToLocationAvailability: {
                  quantity: Number(formData.quantity) || 1,
                },
              },

              // ✅ condition wahi jahan tumne rakha tha
              condition: (formData.condition || "NEW").toUpperCase(),

              packageWeightAndSize: {
                dimensions: {
                  length: "10",
                  width: "8",
                  height: "2",
                  unit: "INCH",
                },
                weight: {
                  value: "1",
                  unit: "POUND",
                },
              },

              product: {
                title: formData.title || "Product",
                description: formData.description || "No description",
                imageUrls: finalImageUrls || [],
                aspects: buildEbayAspects(formData.allCategoryAspects || []),
              },
            },

            offerDetails: {
              pricingSummary: {
                price: {
                  value: String(formData.price || "1.00"),
                  currency: "USD",
                },
              },

              merchantLocationKey:
                savedEbayPolicies?.data?.location || "Warehouse1",

              listingPolicies: {
                fulfillmentPolicyId:
                  savedEbayPolicies?.data?.shipping_policy_id || "",

                paymentPolicyId:
                  savedEbayPolicies?.data?.payment_policy_id || "",

                returnPolicyId: savedEbayPolicies?.data?.return_policy_id || "",
              },
            },
          };

          console.log(ebayPayload);
          try {
            // 1️⃣ UPLOAD TO EBAY
            const ebayRes = await fetch(
              `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/uploadProductToEbayThriftops/${companyId}`,
              {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(ebayPayload),
              },
            );

            const ebayData = await ebayRes.json();
            if (!ebayRes.ok)
              throw new Error(ebayData.message || "eBay upload failed");
          } catch (err) {
            console.error("ERROR:", err);
            alert("Error: " + err.message);
          }
        } catch (err) {
          console.error("eBay Error:", err);
          results.push({
            marketplace: "ebay",
            success: false,
            error: err.message,
          });
          showError(`eBay failed: ${err.message}`);
        }
      }

      if (selectedMps.includes("poshmark")) {
        const poshmarkResult = await uploadToPoshmark();
        results.push({
          marketplace: "poshmark",
          success: poshmarkResult.success,
          data: poshmarkResult.data,
          error: poshmarkResult.error,
        });
        if (poshmarkResult.success) {
          showSuccess(
            "Poshmark listing created successfully! Check your browser.",
          );
        } else {
          showError(`Poshmark failed: ${poshmarkResult.error}`);
        }
      }

      if (selectedMps.includes("vinted")) {
        const vintedResult = await uploadToVinted();
        results.push({
          marketplace: "vinted",
          success: vintedResult.success,
          data: vintedResult.data,
          error: vintedResult.error,
        });
        if (vintedResult.success) {
          showSuccess(
            "Vinted listing created successfully! Check your browser.",
          );
        } else {
          showError(`Vinted failed: ${vintedResult.error}`);
        }
      }

      // ================================
      // CREATE PRODUCT AFTER MP UPLOADS
      // ================================

      const successfulMarketplaces = results.filter((r) => r.success);

      if (successfulMarketplaces.length === 0) {
        throw new Error("All marketplace uploads failed");
      }

      setSubmissionStep("Creating product in database...");

      const createProductRes = await fetch(
        "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/create-product",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_id: companyId,
            title: formData.title,
            sku: formData.sku || `SKU-${Date.now()}`,
            description: formData.description,
            seo_tags: formData.seo_tags || "",
            price: Number(formData.price || 1),
            quantity: Number(formData.quantity || 1),
            images: formData.uploadedImages || [],
          }),
        },
      );

      const createProductData = await createProductRes.json();
      if (!createProductRes.ok) {
        throw new Error(createProductData.error || "Product creation failed");
      }

      const productId = createProductData.product_id;

      for (const mp of successfulMarketplaces) {
        if (mp.marketplace === "ebay") {
          await fetch("/api/ebay-product-insert", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              product_id: productId,
              ebay_item_id:
                mp.data.publishOffer?.listingId || mp.data.draftOffer?.offerId,
              sku: formData.sku,
              title: formData.title,
              description: formData.description,
              quantity: Number(formData.quantity),
              price: Number(formData.price),
              currency: "USD",
              category_id: formData.categoryId,
              ebay_store_id: companyId,
            }),
          });
        }

        if (mp.marketplace === "shopify") {
          console.log("Shopify response:", mp.data?.data);
          const product = mp.data?.data;
          const variant = product?.variants?.[0];

          console.log("Product object:", product);
          console.log("Variant:", variant);

          const metafieldsArray = [];
          if (
            formData.metafields &&
            Object.keys(formData.metafields).length > 0
          ) {
            Object.entries(formData.metafields).forEach(([key, value]) => {
              if (value?.trim()) {
                const metafieldDef = activeMetafields.find(
                  (mf) => mf.key === key,
                );
                metafieldsArray.push({
                  namespace: metafieldDef?.namespace || "custom",
                  key: key,
                  value: value,
                  type: metafieldDef?.type || "single_line_text_field",
                });
              }
            });
          }

          await fetch(
            "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/shopify-product-insert",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                product_id: productId,
                shopify_product_id: product?.id,
                shopify_variant_id: variant?.id,
                inventory_item_id: variant?.inventory_item_id,
                sku: variant?.sku,
                barcode: variant?.barcode || null,
                product_type: product?.product_type,
                vendor: product?.vendor,
                price: variant?.price,
                compare_at_price: variant?.compare_at_price,
                quantity: variant?.inventory_quantity,
                tags: product?.tags || [],
                variants: product?.variants || [],
                metafields: metafieldsArray,
                shopify_store_id: companyId,
              }),
            },
          );
        }
      }

      setSubmissionStep("Finalizing...");
      const successful = results.filter((r) => r.success).length;
      const failed = results.filter((r) => !r.success).length;
      setSubmissionSuccess(true);
      setTimeout(() => {
        if (failed === 0) {
          showSuccess(`All ${successful} marketplace(s) listed successfully!`);
          setTimeout(() => {
            localStorage.removeItem("appState_addProduct");
            window.location.reload();
          }, 1500);
        } else {
          showWarning(
            `${successful} succeeded, ${failed} failed. Your draft has been saved.`,
          );
          setIsSubmitting(false);
        }
      }, 2000);
    } catch (err) {
      console.error("Global Error:", err);
      showError(err.message || "Something went wrong");
      setIsSubmitting(false);
    }
  };

  const handleExportCSV = () => {
    if (!formData) return;
    const headers = [
      "Marketplace",
      "Title",
      "Description",
      "SKU",
      "Price",
      "Quantity",
      "Brand",
      "Category",
      "Condition",
      "Color",
      "Variants",
    ];
    const rows = [];
    rows.push([
      "All Marketplaces",
      formData.title,
      formData.description,
      formData.sku,
      formData.price,
      formData.quantity,
      formData.brand,
      formData.category,
      formData.condition,
      formData.color,
      formData.variants
        .map((v) => `Size: ${v.size}, Color: ${v.color}, SKU: ${v.sku}`)
        .join(" | "),
    ]);
    formData.selectedMarketplaces.forEach((id) => {
      let marketplaceName = marketplaces.find((m) => m.id === id)?.name || id;
      let row = [
        marketplaceName,
        formData.title,
        formData.description,
        formData.sku,
        formData.price,
        formData.quantity,
        formData.brand,
        formData.category,
        formData.condition,
        formData.color,
        formData.variants
          .map((v) => `Size: ${v.size}, Color: ${v.color}, SKU: ${v.sku}`)
          .join(" | "),
      ];
      rows.push(row);
    });
    const csvContent = [
      headers.join(","),
      ...rows.map((r) => r.map((v) => `"${v}"`).join(",")),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "product_listing.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {isAutoFilling && (
        <AutoFillLoader message={autoFillMessages[autoFillMessageIndex]} />
      )}
      {isSubmitting && (
        <SubmissionLoader step={submissionStep} isSuccess={submissionSuccess} />
      )}
      <Joyride
        steps={stepstofollow}
        run={run}
        stepIndex={stepIndex}
        callback={handleJoyrideCallback}
        continuous={false}
        showSkipButton={false}
        hideCloseButton={true}
        disableCloseOnEsc={true}
        spotlightClicks={true}
        styles={{
          options: {
            overlayColor: "rgba(0,0,0,0.85)",
            zIndex: 10000,
          },
        }}
      />
      <MDBContainer fluid className="add-product-wizard">
        <div className="wizard-container">
          <div className="wizard-header">
            <h1 className="wizard-title">Add Product</h1>
            <p className="wizard-subtitle">
              Create a new product listing in 5 simple steps
            </p>
          </div>

          <div className="stepper">
            {steps.map((step, index) => (
              <div key={step.id} className="step-container">
                <div
                  className={`step ${currentStep >= step.id ? "active" : ""} ${
                    currentStep === step.id ? "current" : ""
                  } ${isStepClickable(step.id) ? "clickable" : "disabled"}`}
                >
                  <div
                    className="step-number"
                    onClick={() => goToStep(step.id)}
                    style={{
                      cursor: isStepClickable(step.id) ? "pointer" : "default",
                    }}
                  >
                    {currentStep > step.id ? "✓" : step.id}
                  </div>
                  <div className="step-label">{step.title}</div>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`step-connector ${
                      currentStep > step.id ? "completed" : ""
                    }`}
                  ></div>
                )}
              </div>
            ))}
          </div>

          <div className="step-content">
            {currentStep === 1 && (
              <div className="step-panel">
                <div className="step-header">
                  <h2>Upload Product Images</h2>
                  <p>Add high-quality images of your product</p>
                </div>
                <div
                  id="image-upload"
                  className="upload-area"
                  onDragOver={handleDragOver}
                  onDrop={handleDragDrop}
                  onClick={() => {
                    stepIndex === 0 && moveNext();
                    !formData.imageProcessing &&
                      document.getElementById("file-input").click();
                  }}
                >
                  <input
                    id="file-input"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    multiple
                    style={{ display: "none" }}
                    onChange={handleFileUpload}
                  />
                  {formData.imageProcessing ? (
                    <ImageUploadLoader
                      messages={blurMessages}
                      activeIndex={blurTextIndex}
                    />
                  ) : formData.uploadedImages.length > 0 ? (
                    <div className="image-preview-container">
                      {formData.uploadedImages.map((img, index) => (
                        <div key={index} className="image-preview">
                          <img src={img} alt={`Product ${index + 1}`} />
                          <span
                            className="image-cross"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeImage(index);
                            }}
                          >
                            ×
                          </span>
                          <span
                            className={`blur-badge ${
                              formData.blurStatuses[index] ? "blurred" : "ok"
                            }`}
                          >
                            {formData.blurStatuses[index] ? "Blur!" : "OK"}
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="upload-placeholder">
                      <div className="upload-icon">📷</div>
                      <h3>Drop Images OR Click to Upload</h3>
                      <p>JPG, PNG, WebP • Max 5MB</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {currentStep === 2 && (
              <div className="step-panel">
                {processingImages && (
                  <div className="progress-bar-wrapper my-3">
                    <div
                      className="progress-bar-bg"
                      style={{
                        width: "100%",
                        height: "6px",
                        background: "#eee",
                        borderRadius: "4px",
                      }}
                    >
                      <div
                        className="progress-bar-fill"
                        style={{
                          width: `${progress}%`,
                          height: "100%",
                          background: "#6a1b9a",
                          borderRadius: "4px",
                          transition: "width 0.3s",
                        }}
                      />
                    </div>
                    <span style={{ fontSize: "14px", color: "#555" }}>
                      {progress}% {blurMessages[blurTextIndex]}
                    </span>
                  </div>
                )}
                <div className="step-header">
                  <h2>Listing Details</h2>
                  <p>Add comprehensive product information</p>
                  <MDBBtn
                    color="light"
                    size="sm"
                    className="auto-fill-btn"
                    onClick={handleAutoFill}
                  >
                    Auto-Fill Listing
                  </MDBBtn>
                </div>
                <MDBRow>
                  <MDBCol md="12" className="mb-3">
                    <h4 className="section-title">Required Information</h4>
                  </MDBCol>
                  <MDBCol md="12">
                    <MDBInput
                      label="Product Title *"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={formData.title}
                      onChange={(e) =>
                        handleInputChange("title", e.target.value)
                      }
                      required
                    />
                  </MDBCol>
                  <MDBCol md="12">
                    <MDBTextArea
                      label="Product Description *"
                      rows="4"
                      className="mb-3"
                      value={formData.description}
                      onChange={(e) =>
                        handleInputChange("description", e.target.value)
                      }
                      required
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="SKU *"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={formData.sku}
                      onChange={(e) => handleInputChange("sku", e.target.value)}
                      required
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="Price *"
                      type="number"
                      size="lg"
                      className="mb-3"
                      value={formData.price}
                      onChange={(e) =>
                        handleInputChange("price", e.target.value)
                      }
                      required
                      step="0.01"
                      min="0"
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="Quantity *"
                      type="number"
                      size="lg"
                      className="mb-3"
                      value={formData.quantity}
                      onChange={(e) =>
                        handleInputChange("quantity", e.target.value)
                      }
                      required
                      min="1"
                    />
                  </MDBCol>
                  <MDBCol md="12" className="mb-3 mt-4">
                    <h4 className="section-title">Additional Details</h4>
                  </MDBCol>
                  <MDBCol md="6">
                    <MDBInput
                      label="Brand"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={formData.brand}
                      onChange={(e) =>
                        handleInputChange("brand", e.target.value)
                      }
                    />
                  </MDBCol>
                  <MDBCol md="6">
                    <MDBInput
                      label="Color"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={formData.color}
                      onChange={(e) =>
                        handleInputChange("color", e.target.value)
                      }
                    />
                  </MDBCol>
                  <MDBCol md="6">
                    <MDBInput
                      label="Category"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={formData.category}
                      onChange={(e) =>
                        handleInputChange("category", e.target.value)
                      }
                      placeholder="Women > Clothing > Dresses"
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <select
                      className="form-select form-select-lg mb-3"
                      value={formData.condition}
                      onChange={(e) =>
                        handleInputChange("condition", e.target.value)
                      }
                    >
                      <option value="">Select Condition</option>
                      {conditions.map((condition) => (
                        <option key={condition.value} value={condition.value}>
                          {condition.label}
                        </option>
                      ))}
                    </select>
                  </MDBCol>
                  <MDBCol md="8">
                    <MDBTextArea
                      label="Condition Summary"
                      rows="3"
                      className="mb-3"
                      value={formData.condition_summary}
                      readOnly
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="Authenticity Confidence (%)"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={
                        formData.authenticity_score
                          ? `${formData.authenticity_score}%`
                          : ""
                      }
                      readOnly
                    />
                  </MDBCol>
                  <MDBCol md="8">
                    <MDBTextArea
                      label="Authenticity Summary"
                      rows="2"
                      className="mb-3"
                      value={formData.authenticity_summary}
                      readOnly
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="Material"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={formData.material}
                      onChange={(e) =>
                        handleInputChange("material", e.target.value)
                      }
                    />
                  </MDBCol>
                  <MDBCol md="12">
                    <MDBInput
                      label="Tags / Keywords"
                      type="text"
                      size="lg"
                      className="mb-3"
                      value={formData.tags}
                      onChange={(e) =>
                        handleInputChange("tags", e.target.value)
                      }
                      placeholder="Comma separated tags"
                    />
                  </MDBCol>
                  <MDBCol md="12" className="mb-3 mt-4">
                    <h4 className="section-title">eBay Category Aspects</h4>
                    {loadingAspects ? (
                      <p>Loading eBay aspects...</p>
                    ) : formData.categoryAspects?.length > 0 ? (
                      <MDBRow>
                        {formData.categoryAspects.map((aspect) => (
                          <MDBCol md="4" key={aspect.key}>
                            <MDBInput
                              label={aspect.localizedAspectName}
                              type="text"
                              size="lg"
                              className="mb-3"
                              value={aspect.value}
                              onChange={(e) =>
                                handleAspectChange(aspect.key, e.target.value)
                              }
                            />
                          </MDBCol>
                        ))}
                      </MDBRow>
                    ) : (
                      <p>No aspects available for this category.</p>
                    )}
                  </MDBCol>
                  {activeMetafields.length > 0 && (
                    <>
                      <MDBCol md="12" className="mb-3 mt-4">
                        <h4 className="section-title">Shopify Metafields</h4>
                      </MDBCol>
                      {loadingMetafields ? (
                        <MDBCol md="12">
                          <p>Loading metafields...</p>
                        </MDBCol>
                      ) : (
                        <>
                          {activeMetafields.map((mf) => (
                            <MDBCol md="6" key={mf.id}>
                              {mf.type === "multi_line_text_field" ? (
                                <MDBTextArea
                                  label={`${mf.name} - ${mf.key}`}
                                  rows="3"
                                  className="mb-3"
                                  value={formData.metafields?.[mf.key] || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      `metafields.${mf.key}`,
                                      e.target.value,
                                    )
                                  }
                                />
                              ) : (
                                <MDBInput
                                  label={`${mf.name} - ${mf.key}`}
                                  type="text"
                                  size="lg"
                                  className="mb-3"
                                  value={formData.metafields?.[mf.key] || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      `metafields.${mf.key}`,
                                      e.target.value,
                                    )
                                  }
                                />
                              )}
                            </MDBCol>
                          ))}
                        </>
                      )}
                    </>
                  )}
                  <MDBCol md="12" className="variants-section mt-4">
                    <div className="variants-header d-flex justify-content-between align-items-center mb-3">
                      <h4 className="section-title">Product Variants</h4>
                      <MDBBtn
                        size="sm"
                        className="btn-red-outline"
                        onClick={addVariant}
                      >
                        + Add Variant
                      </MDBBtn>
                    </div>
                    {formData.variants.map((variant, index) => (
                      <div
                        key={variant.id}
                        className="variant-card mb-3 p-3 border rounded"
                      >
                        <div className="variant-header d-flex justify-content-between align-items-center mb-2">
                          <h5>Variant {index + 1}</h5>
                          {formData.variants.length > 1 && (
                            <MDBBtn
                              size="sm"
                              color="light"
                              onClick={() => removeVariant(variant.id)}
                            >
                              Remove
                            </MDBBtn>
                          )}
                        </div>
                        <MDBRow>
                          <MDBCol md="4">
                            <MDBInput
                              label="Size"
                              type="text"
                              className="mb-3"
                              value={variant.size}
                              onChange={(e) =>
                                handleVariantChange(
                                  variant.id,
                                  "size",
                                  e.target.value,
                                )
                              }
                            />
                          </MDBCol>
                          <MDBCol md="4">
                            <MDBInput
                              label="Color"
                              type="text"
                              className="mb-3"
                              value={variant.color}
                              onChange={(e) =>
                                handleVariantChange(
                                  variant.id,
                                  "color",
                                  e.target.value,
                                )
                              }
                            />
                          </MDBCol>
                          <MDBCol md="4">
                            <MDBInput
                              label="Variant SKU"
                              type="text"
                              className="mb-3"
                              value={variant.sku}
                              onChange={(e) =>
                                handleVariantChange(
                                  variant.id,
                                  "sku",
                                  e.target.value,
                                )
                              }
                            />
                          </MDBCol>
                        </MDBRow>
                      </div>
                    ))}
                  </MDBCol>
                </MDBRow>
              </div>
            )}

            {currentStep === 3 && (
              <div className="step-panel">
                {processingImages && (
                  <div className="progress-bar-wrapper my-3">
                    <div
                      className="progress-bar-bg"
                      style={{
                        width: "100%",
                        height: "6px",
                        background: "#eee",
                        borderRadius: "4px",
                      }}
                    >
                      <div
                        className="progress-bar-fill"
                        style={{
                          width: `${progress}%`,
                          height: "100%",
                          background: "#6a1b9a",
                          borderRadius: "4px",
                          transition: "width 0.3s",
                        }}
                      ></div>
                    </div>
                    <span style={{ fontSize: "14px", color: "#555" }}>
                      {progress}% Processing Images...
                    </span>
                  </div>
                )}
                <div className="step-header">
                  <h2>Select Marketplaces</h2>
                  <p>Choose where you want to list your product</p>
                </div>
                <div className="marketplace-grid">
                  {availableMarketplaces.map((marketplace) => (
                    <div
                      key={marketplace.id}
                      className={`marketplace-card ${
                        formData.selectedMarketplaces.includes(marketplace.id)
                          ? "selected"
                          : ""
                      }`}
                    >
                      <div
                        className="marketplace-select-area"
                        onClick={() => handleMarketplaceToggle(marketplace.id)}
                      >
                        <div className="marketplace-logo">
                          <img src={marketplace.logo} alt={marketplace.name} />
                        </div>
                        <h4>{marketplace.name}</h4>
                        <div className="marketplace-check">
                          {formData.selectedMarketplaces.includes(
                            marketplace.id,
                          )
                            ? "✓"
                            : ""}
                        </div>
                      </div>
                      {marketplace.id === "ebay" && (
                        <MDBBtn
                          size="sm"
                          color="light"
                          className="integrate-btn"
                          onClick={handleEbayIntegrate}
                          disabled={checkingEbay}
                        >
                          {checkingEbay
                            ? "Checking..."
                            : ebayConnected
                              ? "Connected"
                              : "Integrate"}
                        </MDBBtn>
                      )}
                      {marketplace.id === "poshmark" && (
                        <MDBBtn
                          size="sm"
                          color="light"
                          className="integrate-btn"
                          onClick={handlePoshmarkIntegrate}
                          disabled={checkingPoshmark}
                        >
                          {checkingPoshmark
                            ? "Checking..."
                            : poshmarkConnected
                              ? "Connected"
                              : "Integrate"}
                        </MDBBtn>
                      )}
                      {marketplace.id === "vinted" && (
                        <MDBBtn
                          size="sm"
                          color="light"
                          className="integrate-btn"
                          onClick={handleVintedIntegrate}
                          disabled={checkingVinted}
                        >
                          {checkingVinted
                            ? "Checking..."
                            : vintedConnected
                              ? "Connected"
                              : "Integrate"}
                        </MDBBtn>
                      )}
                    </div>
                  ))}
                  {upcomingMarketplaces.map((marketplace) => (
                    <div
                      key={marketplace.id}
                      className="marketplace-card upcoming"
                    >
                      <div className="marketplace-logo">
                        <img
                          src={marketplace.logo}
                          alt={`${marketplace.name} logo`}
                        />
                      </div>
                      <h4>{marketplace.name}</h4>
                      <div className="marketplace-badge">Coming Soon</div>
                    </div>
                  ))}
                </div>

                {formData.selectedMarketplaces.includes("poshmark") && (
                  <div
                    className="poshmark-details-section mt-5 p-4"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "12px",
                      background: "#f9f9f9",
                    }}
                  >
                    <h4
                      className="mb-3"
                      style={{
                        color: "#764ba2",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={poshmarkLogo}
                        alt="Poshmark"
                        style={{ width: "28px", marginRight: "10px" }}
                      />
                      Poshmark Listing Details
                    </h4>
                    <MDBRow>
                      <MDBCol md="6">
                        <div className="form-group mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Main Category *
                          </label>
                          <select
                            className="form-select"
                            value={formData.poshmarkCategory || "Women"}
                            onChange={(e) =>
                              handlePoshmarkCategoryChange(e.target.value)
                            }
                            style={{
                              padding: "10px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                              width: "100%",
                            }}
                          >
                            <option value="">Select Category</option>
                            <option value="Women">Women</option>
                            <option value="Men">Men</option>
                            <option value="Kids">Kids</option>
                            <option value="Home">Home</option>
                            <option value="Pets">Pets</option>
                            <option value="Electronics">Electronics</option>
                          </select>
                        </div>
                      </MDBCol>
                      <MDBCol md="6">
                        <div className="form-group mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Sub Category *
                          </label>
                          <select
                            className="form-select"
                            value={formData.poshmarkSubCategory || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "poshmarkSubCategory",
                                e.target.value,
                              )
                            }
                            style={{
                              padding: "10px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                              width: "100%",
                            }}
                            disabled={!formData.poshmarkCategory}
                          >
                            <option value="">Select Subcategory</option>
                            {poshmarkSubCategories.map((sub) => (
                              <option key={sub} value={sub}>
                                {sub}
                              </option>
                            ))}
                          </select>
                        </div>
                      </MDBCol>
                      <MDBCol md="4">
                        <div className="form-group mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Size Type
                          </label>
                          <select
                            className="form-select"
                            value={formData.poshmarkSizeType || "standard"}
                            onChange={(e) =>
                              handleInputChange(
                                "poshmarkSizeType",
                                e.target.value,
                              )
                            }
                            style={{
                              padding: "10px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                              width: "100%",
                            }}
                          >
                            <option value="standard">Standard</option>
                            <option value="custom">Custom</option>
                          </select>
                        </div>
                      </MDBCol>
                      <MDBCol md="4">
                        <div className="form-group mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Size Value
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.variants?.[0]?.size || "OS"}
                            onChange={(e) => {
                              if (formData.variants.length > 0) {
                                handleVariantChange(
                                  formData.variants[0].id,
                                  "size",
                                  e.target.value,
                                );
                              }
                            }}
                            style={{
                              padding: "10px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                              width: "100%",
                            }}
                            placeholder="OS or 10"
                          />
                        </div>
                      </MDBCol>
                      <MDBCol md="4">
                        <div className="form-group mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Original Price (Optional)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.pricerange?.split(" - ")[1] || ""}
                            onChange={(e) => {
                              const low =
                                formData.pricerange?.split(" - ")[0] ||
                                formData.price;
                              handleInputChange(
                                "pricerange",
                                `${low} - ${e.target.value}`,
                              );
                            }}
                            style={{
                              padding: "10px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                              width: "100%",
                            }}
                            placeholder="Enter original price"
                          />
                        </div>
                      </MDBCol>
                      <MDBCol md="4">
                        <div className="form-group mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Availability
                          </label>
                          <select
                            className="form-select"
                            value={formData.poshmarkAvailability || "available"}
                            onChange={(e) =>
                              handleInputChange(
                                "poshmarkAvailability",
                                e.target.value,
                              )
                            }
                            style={{
                              padding: "10px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                              width: "100%",
                            }}
                          >
                            <option value="available">For Sale</option>
                            <option value="not_for_sale">Not For Sale</option>
                            <option value="coming_soon">Drops</option>
                          </select>
                        </div>
                      </MDBCol>
                      <MDBCol md="4">
                        <div className="form-group mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Color
                          </label>
                          <select
                            className="form-select"
                            value={formData.color || ""}
                            onChange={(e) =>
                              handleInputChange("color", e.target.value)
                            }
                            style={{
                              padding: "10px",
                              borderRadius: "8px",
                              border: "2px solid #ddd",
                              width: "100%",
                            }}
                          >
                            <option value="">Select Color</option>
                            <option>Red</option>
                            <option>Blue</option>
                            <option>Black</option>
                            <option>White</option>
                            <option>Green</option>
                            <option>Beige</option>
                            <option>Brown</option>
                            <option>Gray</option>
                            <option>Pink</option>
                            <option>Purple</option>
                          </select>
                        </div>
                      </MDBCol>
                    </MDBRow>
                    <div
                      className="mt-3 p-3"
                      style={{
                        borderRadius: "8px",
                        backgroundColor: poshmarkConnected
                          ? "#d4edda"
                          : "#fff3cd",
                        color: poshmarkConnected ? "#155724" : "#856404",
                        border: `1px solid ${poshmarkConnected ? "#c3e6cb" : "#ffeeba"}`,
                      }}
                    >
                      <strong>Poshmark Extension Status:</strong>{" "}
                      {poshmarkConnected
                        ? "Connected - Ready to list!"
                        : "Not connected - Click 'Integrate' button above"}
                    </div>
                  </div>
                )}

                {formData.selectedMarketplaces.includes("vinted") && (
                  <div
                    className="vinted-details-section mt-5 p-4"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "12px",
                      background: "#f9f9f9",
                    }}
                  >
                    <h4
                      className="mb-3"
                      style={{
                        color: "#7B61FF",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ fontSize: "28px", marginRight: "10px" }}>
                        👕
                      </span>
                      Vinted Listing Details
                    </h4>

                    <div className="form-group mb-4">
                      <label
                        style={{
                          fontWeight: "600",
                          display: "block",
                          marginBottom: "10px",
                        }}
                      >
                        Category Selection *
                      </label>

                      {!formData.vintedCategoryId ? (
                        <div
                          className="category-selection-container"
                          style={{
                            border: "2px solid #e0e0e0",
                            borderRadius: "8px",
                            padding: "15px",
                            background: "white",
                          }}
                        >
                          {vintedSelectedCategoryPath.length > 0 && (
                            <div
                              className="category-breadcrumb"
                              style={{
                                fontSize: "14px",
                                color: "#666",
                                marginBottom: "15px",
                                padding: "8px 12px",
                                background: "#f5f5f5",
                                borderRadius: "6px",
                              }}
                            >
                              Categories:{" "}
                              {vintedSelectedCategoryPath.map((cat, i) => (
                                <span key={i}>
                                  {i > 0 && " › "}
                                  <span
                                    style={{
                                      color: "#7B61FF",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {cat}
                                  </span>
                                </span>
                              ))}
                            </div>
                          )}

                          {vintedCategoryHistory.length > 0 && (
                            <button
                              className="btn btn-sm btn-light mb-3"
                              onClick={handleVintedBack}
                              style={{
                                padding: "8px 16px",
                                background: "#f0f0f0",
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                              }}
                            >
                              ← Back
                            </button>
                          )}

                          {vintedLoadingCategories ? (
                            <div
                              style={{ textAlign: "center", padding: "30px" }}
                            >
                              <div
                                style={{
                                  border: "3px solid #f3f3f3",
                                  borderTop: "3px solid #7B61FF",
                                  borderRadius: "50%",
                                  width: "30px",
                                  height: "30px",
                                  animation: "spin 1s linear infinite",
                                  margin: "0 auto 10px",
                                }}
                              ></div>
                              <div style={{ color: "#666" }}>
                                Loading categories...
                              </div>
                            </div>
                          ) : (
                            <div
                              className="categories-list"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                                border: "1px solid #e0e0e0",
                                borderRadius: "6px",
                              }}
                            >
                              {(vintedCurrentCategoryId === null
                                ? vintedMainCategories
                                : vintedSubCategories
                              ).map((cat) => (
                                <div
                                  key={cat.category_id}
                                  className="category-item"
                                  onClick={() => handleVintedCategoryClick(cat)}
                                  style={{
                                    padding: "12px 15px",
                                    borderBottom: "1px solid #eee",
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    transition: "background 0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.background =
                                      "#f5f2ff")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = "white")
                                  }
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "20px",
                                        marginRight: "10px",
                                        minWidth: "24px",
                                      }}
                                    >
                                      {getVintedCategoryIcon(cat.name)}
                                    </span>
                                    <div>
                                      <div style={{ fontWeight: 500 }}>
                                        {cat.name}
                                      </div>
                                      {cat.is_final_selection && (
                                        <div
                                          style={{
                                            fontSize: "11px",
                                            color: "#7B61FF",
                                          }}
                                        >
                                          Click to select
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {!cat.is_final_selection && (
                                    <span style={{ color: "#999" }}>→</span>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div
                          style={{
                            background: "#E8F5E9",
                            border: "2px solid #7B61FF",
                            borderRadius: "8px",
                            padding: "15px",
                            marginBottom: "20px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              color: "#2E7D32",
                              marginBottom: "5px",
                            }}
                          >
                            Selected: {formData.vintedCategoryPath.join(" > ")}
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              marginBottom: "10px",
                            }}
                          >
                            Category ID: {formData.vintedCategoryId}
                          </div>
                          <button
                            className="btn btn-sm btn-link"
                            style={{
                              color: "#7B61FF",
                              padding: 0,
                              border: "none",
                              background: "none",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={resetVintedCategory}
                          >
                            Change Category
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="form-group mb-4">
                      <label
                        style={{
                          fontWeight: "600",
                          display: "block",
                          marginBottom: "10px",
                        }}
                      >
                        Package Size *
                      </label>
                      <div
                        className="package-size-container"
                        style={{
                          border: "2px solid #e0e0e0",
                          borderRadius: "8px",
                          padding: "15px",
                          background: "white",
                        }}
                      >
                        <div
                          className={`package-option ${
                            formData.vintedPackageSize === "small"
                              ? "selected"
                              : ""
                          }`}
                          onClick={() =>
                            handleInputChange("vintedPackageSize", "small")
                          }
                          style={{
                            border:
                              "2px solid " +
                              (formData.vintedPackageSize === "small"
                                ? "#7B61FF"
                                : "#ddd"),
                            borderRadius: "8px",
                            padding: "15px",
                            marginBottom: "10px",
                            cursor: "pointer",
                            background:
                              formData.vintedPackageSize === "small"
                                ? "#F5F2FF"
                                : "white",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-block",
                              background: "#00D4AA",
                              color: "white",
                              padding: "4px 10px",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: 600,
                              marginBottom: "8px",
                            }}
                          >
                            Recommended
                          </div>
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "16px",
                              marginBottom: "5px",
                            }}
                          >
                            Small
                          </div>
                          <div
                            style={{
                              color: "#666",
                              fontSize: "14px",
                              marginBottom: "5px",
                            }}
                          >
                            For items that'd fit in a large envelope.
                          </div>
                        </div>
                        <div
                          className={`package-option ${
                            formData.vintedPackageSize === "medium"
                              ? "selected"
                              : ""
                          }`}
                          onClick={() =>
                            handleInputChange("vintedPackageSize", "medium")
                          }
                          style={{
                            border:
                              "2px solid " +
                              (formData.vintedPackageSize === "medium"
                                ? "#7B61FF"
                                : "#ddd"),
                            borderRadius: "8px",
                            padding: "15px",
                            marginBottom: "10px",
                            cursor: "pointer",
                            background:
                              formData.vintedPackageSize === "medium"
                                ? "#F5F2FF"
                                : "white",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "16px",
                              marginBottom: "5px",
                            }}
                          >
                            Medium
                          </div>
                          <div
                            style={{
                              color: "#666",
                              fontSize: "14px",
                              marginBottom: "5px",
                            }}
                          >
                            For items that'd fit in a shoebox.
                          </div>
                        </div>
                        <div
                          className={`package-option ${
                            formData.vintedPackageSize === "large"
                              ? "selected"
                              : ""
                          }`}
                          onClick={() =>
                            handleInputChange("vintedPackageSize", "large")
                          }
                          style={{
                            border:
                              "2px solid " +
                              (formData.vintedPackageSize === "large"
                                ? "#7B61FF"
                                : "#ddd"),
                            borderRadius: "8px",
                            padding: "15px",
                            cursor: "pointer",
                            background:
                              formData.vintedPackageSize === "large"
                                ? "#F5F2FF"
                                : "white",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "16px",
                              marginBottom: "5px",
                            }}
                          >
                            Large
                          </div>
                          <div
                            style={{
                              color: "#666",
                              fontSize: "14px",
                            }}
                          >
                            For items that'd fit in a moving box.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-3">
                      <label
                        style={{
                          fontWeight: "600",
                          display: "block",
                          marginBottom: "6px",
                        }}
                      >
                        Product Size (Optional)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g., M, L, 8, 10"
                        value={formData.vintedSize}
                        onChange={(e) =>
                          handleInputChange("vintedSize", e.target.value)
                        }
                        style={{
                          padding: "12px",
                          borderRadius: "8px",
                          border: "2px solid #ddd",
                          width: "100%",
                        }}
                      />
                    </div>

                    <div
                      className="mt-3 p-3"
                      style={{
                        borderRadius: "8px",
                        backgroundColor: vintedConnected
                          ? "#d4edda"
                          : "#fff3cd",
                        color: vintedConnected ? "#155724" : "#856404",
                        border: `1px solid ${vintedConnected ? "#c3e6cb" : "#ffeeba"}`,
                      }}
                    >
                      <strong>Vinted Extension Status:</strong>{" "}
                      {vintedConnected
                        ? "Connected - Ready to list!"
                        : "Not connected - Click 'Integrate' button above"}
                    </div>
                  </div>
                )}
              </div>
            )}

            {currentStep === 4 && (
              <div className="step-panel">
                <div className="step-header">
                  <h2>Image Processing</h2>
                  <p>Select enhancements to apply to your images</p>
                </div>
                <div className="image-options">
                  <div className="checkbox-wrapper">
                    <MDBCheckbox
                      label="Background Removal"
                      checked={formData.backgroundRemoval}
                      onChange={(e) =>
                        handleInputChange("backgroundRemoval", e.target.checked)
                      }
                    />
                  </div>
                  <div className="checkbox-wrapper">
                    <MDBCheckbox
                      label="Upscale Image"
                      checked={formData.upscaleImage}
                      onChange={(e) =>
                        handleInputChange("upscaleImage", e.target.checked)
                      }
                    />
                  </div>
                </div>
                <MDBBtn
                  className="mt-3"
                  disabled={processing}
                  onClick={handleStartImageEditing}
                >
                  {processing ? "Processing..." : "Start Image Processing"}
                </MDBBtn>
                {processingImages && (
                  <div className="progress-bar-wrapper mt-3">
                    <div className="progress-bar-bg">
                      <div
                        className="progress-bar-fill"
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                    <span>{progress}% Processing</span>
                  </div>
                )}
                {processedImages.length > 0 && (
                  <div className="processed-images mt-4">
                    {processedImages.map((img, i) => (
                      <img key={i} src={img} alt={`Processed ${i}`} />
                    ))}
                  </div>
                )}
              </div>
            )}

            {currentStep === 5 && (
              <div className="step-panel">
                <div className="step-header">
                  <h2>Review & Submit</h2>
                  <p>Please review your product details before submitting</p>
                </div>
                <div className="review-sections">
                  <div className="review-section">
                    <h4>Product Images</h4>
                    <div className="review-image">
                      {(processedImages.length
                        ? processedImages
                        : formData.uploadedImages
                      ).map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`Product ${index + 1}`}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="review-section">
                    <h4>Product Details</h4>
                    <div className="review-grid">
                      <div className="review-item">
                        <strong>Title:</strong> {formData.title}
                      </div>
                      <div className="review-item">
                        <strong>Description:</strong> {formData.description}
                      </div>
                      <div className="review-item">
                        <strong>SKU:</strong> {formData.sku}
                      </div>
                      <div className="review-item">
                        <strong>Price:</strong> ${formData.price}
                      </div>
                      <div className="review-item">
                        <strong>Quantity:</strong> {formData.quantity}
                      </div>
                      {formData.brand && (
                        <div className="review-item">
                          <strong>Brand:</strong> {formData.brand}
                        </div>
                      )}
                      {formData.category && (
                        <div className="review-item">
                          <strong>Category:</strong> {formData.category}
                        </div>
                      )}
                    </div>
                  </div>
                  {formData.variants.some(
                    (v) => v.size || v.color || v.sku,
                  ) && (
                    <div className="review-section">
                      <h4>Product Variants</h4>
                      <div className="variants-review">
                        {formData.variants.map((variant, index) => (
                          <div key={variant.id} className="variant-review-item">
                            <strong>Variant {index + 1}:</strong>
                            {variant.size && <span>Size: {variant.size}</span>}
                            {variant.color && (
                              <span>Color: {variant.color}</span>
                            )}
                            {variant.sku && <span>SKU: {variant.sku}</span>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="review-section">
                    <h4>Selected Marketplaces</h4>
                    <div className="selected-marketplaces">
                      {formData.selectedMarketplaces.map((id) => {
                        const marketplace = marketplaces.find(
                          (m) => m.id === id,
                        );
                        if (!marketplace) return null;
                        return (
                          <div key={id} className="marketplace-preview">
                            <span className="marketplace-badge">
                              {marketplace.name}
                            </span>
                            <div className="marketplace-details">
                              {id === "shopify" && (
                                <div className="review-grid">
                                  <div className="review-item">
                                    <strong>Title:</strong> {formData.title}
                                  </div>
                                  <div className="review-item">
                                    <strong>Description:</strong>{" "}
                                    {formData.description}
                                  </div>
                                  <div className="review-item">
                                    <strong>Price:</strong> ${formData.price}
                                  </div>
                                  <div className="review-item">
                                    <strong>SKU:</strong> {formData.sku}
                                  </div>
                                </div>
                              )}
                              {id === "ebay" && (
                                <div className="review-grid">
                                  <div className="review-item">
                                    <strong>Title:</strong> {formData.title}
                                  </div>
                                  <div className="review-item">
                                    <strong>SKU:</strong> {formData.sku}
                                  </div>
                                  <div className="review-item">
                                    <strong>Price:</strong> ${formData.price}
                                  </div>
                                </div>
                              )}
                              {id === "poshmark" && (
                                <div className="review-grid">
                                  <div className="review-item">
                                    <strong>Title:</strong> {formData.title}
                                  </div>
                                  <div className="review-item">
                                    <strong>Description:</strong>{" "}
                                    {formData.description?.substring(0, 50)}...
                                  </div>
                                  <div className="review-item">
                                    <strong>Category:</strong>{" "}
                                    {formData.poshmarkCategory || "Women"} &gt;{" "}
                                    {formData.poshmarkSubCategory || "Dresses"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Brand:</strong>{" "}
                                    {formData.brand || "N/A"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Price:</strong> ${formData.price}
                                    {formData.pricerange?.split(" - ")[1] && (
                                      <small
                                        style={{
                                          marginLeft: "8px",
                                          color: "#666",
                                        }}
                                      >
                                        (Original: $
                                        {formData.pricerange?.split(" - ")[1]})
                                      </small>
                                    )}
                                  </div>
                                  <div className="review-item">
                                    <strong>Size:</strong>{" "}
                                    {formData.variants?.[0]?.size || "OS"} (
                                    {formData.poshmarkSizeType || "standard"})
                                  </div>
                                  <div className="review-item">
                                    <strong>Condition:</strong>{" "}
                                    {formData.condition || "New With Tags"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Color:</strong>{" "}
                                    {formData.color || "Not specified"}
                                  </div>
                                  <div
                                    className="review-item"
                                    style={{
                                      color: poshmarkConnected
                                        ? "green"
                                        : "red",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <strong>Extension:</strong>{" "}
                                    {poshmarkConnected
                                      ? "Connected"
                                      : "Not Connected"}
                                  </div>
                                </div>
                              )}
                              {id === "vinted" && (
                                <div className="review-grid">
                                  <div className="review-item">
                                    <strong>Title:</strong> {formData.title}
                                  </div>
                                  <div className="review-item">
                                    <strong>Description:</strong>{" "}
                                    {formData.description?.substring(0, 50)}...
                                  </div>
                                  <div className="review-item">
                                    <strong>Category:</strong>{" "}
                                    {formData.vintedCategoryPath.join(" > ") ||
                                      formData.vintedCategory ||
                                      "Not selected"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Brand:</strong>{" "}
                                    {formData.brand || "N/A"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Price:</strong> ${formData.price}
                                  </div>
                                  <div className="review-item">
                                    <strong>Size:</strong>{" "}
                                    {formData.vintedSize || "Not specified"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Package Size:</strong>{" "}
                                    {formData.vintedPackageSize === "small"
                                      ? "Small"
                                      : formData.vintedPackageSize === "medium"
                                        ? "Medium"
                                        : "Large"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Condition:</strong>{" "}
                                    {formData.condition || "Very good"}
                                  </div>
                                  <div className="review-item">
                                    <strong>Color:</strong>{" "}
                                    {formData.color || "Not specified"}
                                  </div>
                                  <div
                                    className="review-item"
                                    style={{
                                      color: vintedConnected ? "green" : "red",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <strong>Extension:</strong>{" "}
                                    {vintedConnected
                                      ? "Connected"
                                      : "Not Connected"}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="wizard-navigation">
            <MDBBtn
              color="light"
              disabled={currentStep === 1}
              onClick={prevStep}
              className="nav-btn"
            >
              Back
            </MDBBtn>
            {currentStep < steps.length ? (
              <MDBBtn
                className="btn-red"
                disabled={!isStepValid()}
                onClick={nextStep}
              >
                Next
              </MDBBtn>
            ) : (
              <>
                <MDBBtn
                  className="btn-red"
                  onClick={handleSubmit}
                  disabled={processingImages || isSubmitting}
                >
                  {isSubmitting ? "Creating..." : "Create Listing"}
                </MDBBtn>
                <MDBBtn
                  className="btn-outline-dark ms-3"
                  onClick={handleExportCSV}
                  disabled={processingImages}
                >
                  Export CSV
                </MDBBtn>
              </>
            )}
          </div>
        </div>
      </MDBContainer>
      <MessageBoxComponent />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default AddProduct;
